import React from "react"
import BookingRow from "./BookingRow"

const RowComponent = ({ days, reloadData }) => (
  <>
    { days?.length && days.map(day => {
        const {
          bookings, date, totalPrice, targetAmount, targetCompletePercentage, startAt, endAt, totalDuration, totalOperationValue
        } = day

        return (
          <>
            { bookings.map(booking => (
              <BookingRow booking={booking} reloadData={reloadData} />
            ))}
            <tr className="font-weight-bold text-white" style={{ backgroundColor: "#6c757d" }}>
              <td></td>
              <td>{startAt}</td>
              <td>{endAt}</td>
              <td>{totalDuration}</td>
              <td></td>
              <td className="text-right">Target:</td>
              <td>{targetAmount}</td>
              <td>{`${targetCompletePercentage}%`}</td>
              <td className="text-right">{totalPrice}</td>
              <td className="text-right">{totalOperationValue}</td>
            </tr>
          </>
        )
    })}
  </>
  )

export default RowComponent